import { Environment } from '../app/shared/env/environment.interface';

export const environment: Environment = {
  isLocalEnvironment: false,
  isDevEnvironment: true,
  authentication: true,
  production: false,
  trimAlias: true,
  tenantAdminId: '6e11b5ed-72b5-49f4-b0ac-5c58681d5a46',
  OIDC_SETTINGS: {
    authority: 'https://login.microsoftonline.com/26b749f6-8c72-44e3-bbde-ae3de07b4206/v2.0',
    clientId: 'd1f0b992-946c-4af1-bd3d-6ff0494585ca',
    redirectUri: `${window.location.origin}/signin-callback`,
    scope: 'api://f6a1394b-55a0-4a2c-8772-e928bb9d58a0/default openid profile email',
    silentRedirectUri: `${window.location.origin}/silent-callback`,
    postLogoutRedirectUri: `${window.location.origin}`,
  },
  MODEL_VIEWER_CONFIG: {
    modelViewerAuthBaseUrl: '/api/model3dprofiles/{profileId}/proxy',
    cdf_project: 'integral-test',
  },
  USERPILOT_CONFIG: {
    enabled: true,
  },
  TRACKING_CONFIG: {
    enabled: true,
    prefix: 'IEX',
    env: 'dev',
  },
};
